export const PLANS = {
  1: 'free',
  2: 'lite',
  3: 'guru',
  4: 'pro'
};

export default PLANS;
